import { createFeatureSelector } from '@ngrx/store';

import {
  ModalControlsLoadable,
  ModalControlsLoadableFactory,
} from '®shared/modals';

import { Review } from '../review';

export const STATE_FEATURE_REVIEW_HISTORY = 'reviewHistory';

export interface ReviewHistoryState {
  listId: string | null;
  modalControls: ModalControlsLoadable<Review[]>;
}

export const REVIEW_HISTORY_INITIAL_STATE: ReviewHistoryState = {
  listId: null,
  modalControls: ModalControlsLoadableFactory.hide(),
};

export function getInitialReviewHistoryState(): ReviewHistoryState {
  return REVIEW_HISTORY_INITIAL_STATE;
}

export const selectReviewHistoryState =
  createFeatureSelector<ReviewHistoryState>(STATE_FEATURE_REVIEW_HISTORY);
